<template>
    <div class="row page">
        <div class="form-account form-sign-in">
            <div class="form-account__welcome" v-if="hasUsername">
                <i class="fas fa-hand-paper"></i>
                <h5>Welcome {{getUsername}}</h5>
            </div>
            <h1>Sign in</h1>
            <div v-if="newAccount" class="col-12 alert alert-success" role="alert">
                Your account has been created. Please sign in to continue.
            </div>
            <form>
                <ul>
                    <li>
                        <label for="email">Email address</label>
                        <input id="email" type="text" v-model="username" autocomplete="username" class="form-account__email">
                    </li>
                    <li>
                        <label for="password">Password</label>
                        <input id="password" type="password" v-model="password" autocomplete="current-password" class="form-account__password">
                    </li>
                </ul>
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{error}}
                </div>
                <button class="btn btn-primary" v-on:click.prevent="signIn()">Sign in</button>
                <div class="form-account__alt-action"><router-link to="/create-account">Create an account</router-link></div>
                <div class="form-account__alt-action"><router-link to="/forgot-password">Forgot password?</router-link></div>
            </form>
        </div>
    </div>
</template>

<script>
    import { store } from '@/store.js'

    import { signInMixin } from "../mixins/SignInMixin.js"

    export default {
        name: "SignIn.vue",
        data: function () {
            return {
                newAccount: false,
                username: store.host.email,
                password: "",
                error: null
            }
        },
        mixins: [signInMixin],
        computed: {
            hasUsername: function () {
                if (store.host !== undefined && store.host.name !== undefined) {
                    return true;
                }
                return false
            },
            getUsername: function () {
                if (this.hasUsername) {
                    return store.host.name
                }
                return ''
            }
        },
        methods: {
        },
        mounted: function() {
            if (this.$route.query.created) {
                this.newAccount = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/sign-in";
</style>